import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { installI18n } from './i18n'
import './assets/styles/reset.scss'
import './assets/styles/global.scss'

Vue.config.productionTip = false

const app = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

installI18n(router, app)
